export const REGISTRATION_FLOW_TYPE = {
    NEW_VISIT: 'newVisit',
    UPDATE_VISIT: 'updateVisit',
    CANCEL_ATTENDANCE: 'cancelAttendance',
    UPDATE_DEMOGRAPHICS: 'updateDemographics',
    CREATE_TCI: 'createTci',
    FOLLOW_UP_SELECT: 'followUpSelect',
    FOLLOW_UP: 'followUp', // Regular followup with no type and not linked to an activity
    FOLLOW_UP_SDEC: 'followUpSdec',
    FOLLOW_UP_BEDAS: 'followUpBedas',
    FOLLOW_UP_UTC: 'followUpUtc',
    RE_ATTENDANCE: 'reAttendance',
    MERGE_PATIENT: 'mergePatient',
    MERGE_NEW_PATIENT: 'mergeNewPatient',
    BED_BOOKING: 'bedBooking',
};
